import { render, staticRenderFns } from "./PcGrntCtTable.vue?vue&type=template&id=54df5352&"
import script from "./PcGrntCtTable.vue?vue&type=script&lang=js&"
export * from "./PcGrntCtTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports